module.exports = __webpack_public_path__ + "static/media/hewr.377df82e.jpg";